{
  "labels": {
    "language": "Lingua",
    "search": "cerca",
    "share": "Condividi",
    "sharing": "Condivisione",
    "duplicate": "Duplica",
    "export": "Esporta",
    "refresh": "Ricarica",
    "delete": "Elimina",
    "release": "Rilascia",
    "cancel": "Annulla",
    "ok": "OK",
    "create-mashup": "Crea mashup",
    "create": "Create",
    "create-version": "Crea versione",
    "release-version": "Versione Rilasciata",
    "version": "Versione",
    "configure": "Configurazioni",
    "released": "Rilasciata",
    "add-users-to-collaborate": "Aggiungi utenti per collaborare",
    "share-to-collaborate": "Condividi per collaborare",
    "delete-mashup-snackbar-text": "Il mashup è stato eliminato con successo",
    "delete-version-snackbar-text": "La versione è stata eliminata con successo",
    "update-mashup-snackbar-text": "Il mashup è stato aggiornato correttamente",
    "release-version-snackbar-text": "Hai rilasciato una nuova versione",
    "search-user": "Cerca utenti...",
    "no-shared": "Nessun utente condiviso.",
    "share-limitation": "Condividi con limitazione",
    "view-only-mode": "Scegli chi altro può accedere in modalità di sola visualizzazione",
    "rename-mashup": "Rinomina il tuo mashup",
    "mashup-tags": "Inserisci alcuni tag mashup",
    "mashup-versions": "Versioni mashup",
    "datamodel-hint": "Seleziona uno SMART Datamodel prodotto da questo progetto",
    "no-flows": "Non ci sono flussi disponibili per questo Mashup",
    "editor": "editore",
    "owner": "proprietario",
    "no-one": "Nessuno",
    "all-members": "Tutti i membri dell'organizzazione",
    "everyone": "Tutti",
    "no-data-available": "Nessun dato disponibile",
    "from": "Da",
    "flow": "Flussi",
    "save": "Salva",
    "name": "Nome",
    "open": "Apri",
    "close": "Chiudi",
    "login": "Login",
    "mashups": "Mashups",
    "share-confirmation": "Conferma condivisione",
    "confirm": "Conferma",
    "datasources": "Sorgenti di dati",
    "custom-operators": "Operatori personali",
    "mashup": "Mashup",
    "unshare-confirmation": "Conferma annullamento condivisione",
    "check-all": "Seleziona tutto",
    "uncheck-all": "Deseleziona tutto"
  },
  "strings": {
    "create-new-version": "Crea una nuova versione",
    "create-version-hint": "Scrivi un nuovo nome per la tua versione",
    "create-version-from-hint": "Seleziona una versione esistente per iniziarne una nuova da essa",
    "create-version-mashup-text": "La versione è stata creata con successo",
    "overlay-text": "Avrai un'esperienza migliore utilizzando questa applicazione in modalità landscape.",
    "duplicate-mashup-text": "Il mashup è stato duplicato correttamente",
    "create-version-mashup-tooltip": "Crea una nuova versione del mashup",
    "delete-mashup-tooltip": "Solo il proprietario può eliminare questo mashup",
    "unshare-user-tooltip": "Solo il proprietario del mashup può annullare la condivisione con un utente",
    "release-version-tooltip": "Questa versione è stata rilasciata e non può più essere modificata",
    "release-version-button-tooltip": "Crea una nuova versione per questo mashup",
    "delete-mashup-question": "Sei sicuro di voler eliminare questo mashup? | Sei sicuro di voler eliminare questi mashup?",
    "delete-version-question": "Sei sicuro di voler eliminare questa versione?",
    "delete-mashup-shared-question": "Questo mashup è condiviso. Sei sicuro di volerlo eliminare?",
    "release-version": "Sei sicuro di voler rilasciare la versione",
    "release-version-text": "Dopo il rilascio, questa versione non può più essere modificata.",
    "release-version-text-warning": "<b>Attenzione</b>: se il tuo mashup contiene mashup annidati, questi verranno rilasciati automaticamente.",
    "duplicate-mashup-question": "Quale versione vuoi duplicare?",
    "export-mashup-question": "Quale versione vuoi esportare?",
    "mashup-project-name": "Scrivi un nome per il tuo progetto mashup",
    "json-schema-hint": "Inserisci qui lo schema JSON previsto e l'output del mashup verrà convalidato rispetto ad esso",
    "resolve-mashup-issues": "Devi prima risolvere i problemi del mashup...",
    "share-dependencies-intro": "Confermando la condivisione, verranno condivise automaticamente anche le seguenti dipendenze:",
    "confirm-share-dependencies-message": "Vuoi condividerle anche con questo utente?",
    "confirm-unshare-dependencies-message": "Vuoi anche annullare la loro condivisione con questo utente?",
    "export-mashup-tooltip": "Solo il proprietario può esportare il mashup",
    "duplicate-mashup-tooltip": "Solo il proprietario può duplicare il mashup",
    "unshare-dependencies-intro": "Se confermi l'annullamento della condivisione, anche le dipendenze selezionate verranno annullate automaticamente:"
  },
  "errors": {
    "version-name-required": "È richiesto un nome per la tua versione di mashup"
  }
}
